<template>
  <section class="container">
    <read-btn class="read-ls ml-38 sm:ml-6 md:ml-30"/>
    <div class="faq-ls hidden sm:grid card h-40 grid-cols-12 md:mx-24 mt-2">
      <div class="col-start-1 col-end-5 md:col-end-4 bg-primary-dark text-white text-2xl font-strong rounded-l-12p">
        <h1 class="flex justify-center text-2xl text-white items-center shadow-2xl py-4 px-6 h-full">
          {{ text }}
        </h1>
      </div>
      <label for="name" class="hidden">Typ om te zoeken...</label>
      <input
        id="name"
        v-model="query"
        class="col-start-5 md:col-start-4 col-end-12 pl-16 font-strong text-black text-lg placeholder-black focus:placeholder-secondary outline-none"
        type="text"
        placeholder="Typ om te zoeken..."
      >
      <div class="flex items-center bg-white rounded-r-12p">
        <nuxt-link to="/faq" class="btn-round" aria-label="Zoeken">
          <font-awesome-icon :icon="['fas', 'search']"/>
        </nuxt-link>
      </div>
    </div>

    <div class="sm:hidden h-32 grid grid-row-auto grid-cols-12 row-gap-4">
      <div
        :class="$route.name !== 'faq-slug' ? 'col-start-5' : 'col-start-3'"
        class="col-end-13 bg-primary-dark text-white text-2xl font-strong h-32 rounded-l-12p"
      >
        <h1 class="flex justify-center text-2xl text-white items-center py-4 px-6 h-full">
          {{ text }}
        </h1>
      </div>
      <div v-if="$route.name !== 'faq-slug'" class="row-start-2 col-start-1 flex card bg-white h-32 col-end-12">
        <label for="search" class="hidden">Typ om te zoeken...</label>
        <input
          id="search"
          v-model="query"
          class="font-strong pl-8 h-32 w-9/12 text-black text-lg placeholder-black focus:placeholder-secondary outline-none"
          placeholder="Typ om te zoeken..."
        >
        <div class="flex items-center bg-white">
          <nuxt-link to="/faq" class="btn-round" aria-label="Zoeken">
            <font-awesome-icon :icon="['fas', 'search']"/>
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import debounce from 'lodash.debounce';
import ReadBtn from '~/layouts/partials/ReadBtn';

export default {
  components: {
    ReadBtn,
  },
  props: {
    text: {
      type: String,
      default: 'Hey! Hoe kunnen we je helpen?',
    },
  },
  data() {
    return {
      query: '',
    };
  },
  watch: {
    query(val) {
      this.performSearch(val);
    },
  },
  methods: {
    performSearch: debounce(async function (val) {
      await this.$store.dispatch('faqs/getQuestions', val);

      if (val !== '' && this.$route.path !== '/faq') {
        this.$router.push({name: 'faq', params: {noSearch: true}});
      }
    }, 500),
  },
};
</script>

<style lang="sass" scoped>
.faq-ls,
.read-ls
  @media(min-device-width: theme('screens.sm')) and (max-device-width: theme('screens.lg')) and (orientation: landscape)
    margin-left: 0
    margin-right: 0
</style>
